export const SSO_ERROR_STORAGE_KEY = 'app:sso:error';

export const MESSAGES = {
  DISCOVER_INVALID_AUTH: 'Invalid authorization or challenge parameters',
  INVALID_GRANT: 'Sign-in link expired or already used. Enter your email and try again.',
  INVALID_CLIENT: 'Sign-in is temporarily unavailable. Try again later or contact support.',
  SESSION_EXPIRED: 'Sign-in session expired. Enter your email and try again.',
  GENERIC_EXCHANGE: 'Sign-in failed. Please try again.',
  GENERIC_DISCOVER: 'Unable to continue. Please check your email and try again.',
  SSO_NO_EMAIL_MATCH: "We couldn't sign you in. Your identity provider didn't share an email address, "
    + 'or no matching account exists. Please contact your administrator.',
  SSO_ACCESS_DENIED: 'Sign-in was cancelled or denied by your identity provider. Please try again.',
};

const isDiscoverInvalidAuthError = (message = '') => (
  message === MESSAGES.DISCOVER_INVALID_AUTH
  || message.includes('Invalid authorization or challenge parameters')
);

export const getDiscoverErrorMessage = (err) => {
  const message = typeof err === 'string' ? err : err?.message;

  if (isDiscoverInvalidAuthError(message)) {
    return MESSAGES.DISCOVER_INVALID_AUTH;
  }

  if (message) {
    return message;
  }

  return MESSAGES.GENERIC_DISCOVER;
};

const resolveOAuthErrorCode = (body = {}, message = '') => {
  const code = body.code || body.error;

  if (code === 'invalid_grant' || message === 'invalid_grant' || body.error === 'invalid_grant') {
    return 'invalid_grant';
  }

  if (code === 'invalid_client' || message === 'invalid_client' || body.error === 'invalid_client') {
    return 'invalid_client';
  }

  return null;
};

export const getExchangeErrorMessage = (err) => {
  const body = err?.body || {};
  const message = typeof err === 'string' ? err : err?.message;
  const oauthCode = resolveOAuthErrorCode(body, message);

  if (oauthCode === 'invalid_grant') {
    return MESSAGES.INVALID_GRANT;
  }

  if (oauthCode === 'invalid_client') {
    return MESSAGES.INVALID_CLIENT;
  }

  if (message && message !== 'Request failed') {
    return message;
  }

  return MESSAGES.GENERIC_EXCHANGE;
};

export const getMissingClientIdMessage = () => MESSAGES.SESSION_EXPIRED;

// Maps an OAuth/OIDC error returned on the Cognito redirect (?error=&error_description=)
// to a user-facing message. Raw provider descriptions are internal and not shown
// verbatim; callers should log them separately for debugging.
export const getRedirectErrorMessage = ({ error, errorDescription } = {}) => {
  const description = (errorDescription || '').trim();

  // Federated authentication succeeded at the IdP, but the user cannot be
  // provisioned or matched - most commonly because the IdP released no email claim.
  if (/did not provide an email|cannot match to an existing account/i.test(description)) {
    return MESSAGES.SSO_NO_EMAIL_MATCH;
  }

  if (error === 'access_denied') {
    return MESSAGES.SSO_ACCESS_DENIED;
  }

  return MESSAGES.GENERIC_EXCHANGE;
};
